/**
 * Locales whose place names a tenant gets only by listing them in `meta.placeNameLocales`. A live
 * tenant serves Spanish pages with English place names, so turning Spanish ones on for every
 * tenant would change that tenant's pages. Japanese names only some places, the rest in English,
 * so a tenant chooses that mix.
 */
const OPT_IN_PLACE_NAME_LOCALES: readonly string[] = ['es', 'ja'];

/** The locale to name places in on a `locale` page: English for an opt-in-only locale the tenant
 *  has not opted into, and the page's own locale otherwise. */
export function placeNameLocale({
  locale,
  placeNameLocales,
}: {
  locale: string;
  placeNameLocales?: readonly string[] | null;
}): string {
  const optedOut =
    OPT_IN_PLACE_NAME_LOCALES.includes(locale) && !placeNameLocales?.includes(locale);
  return optedOut ? 'en' : locale;
}
